// Footer.js
import React from 'react';
import './Footer.css'; // Import CSS for Footer styling

const Footer = () => {
  return (
    <footer className="footer">
      <p className="copyright">
        &copy; {new Date().getFullYear()} Next Play Hockey. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
